import React, { Component } from "react";
import { Card, Container, Row, Col, Collapse, Table, Button, ProgressBar } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HttpClient from "../../../providers/http/GlasschainMsaHttpClient.js";

import moment from "moment";

import gnome from '../../../assets/images/autopilot-robot-logo-cropped-for-ico-256.png';


export default class AutopilotCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //   tableData: [{receiptLocation: "Totals"}],
      //   totalsOnly: false,
      moreCaret: "caret-down",
      isLoading: false,
      robotData: '',
      isRefreshing: false,
      progress: 0
    };
    this.httpClient = new HttpClient();

    this.refreshTimer = null;
    this.progressTimer = null;

    this.createDisplay = this.createDisplay.bind(this);
    this.createWarehouses = this.createWarehouses.bind(this);
    this.createSublocations = this.createSublocations.bind(this);
    this.refreshData = this.refreshData.bind(this);

    this.tick = this.tick.bind(this);
  }

  async componentDidMount() {
    await this.refreshData();
    await this.tick();
  }

  componentWillUnmount() {
    if ((this.refreshTimer) && (this.refreshTimer !== "")) {
      console.log("clearing refresh interval on componentWillUnmount...");
      clearInterval(this.refreshTimer);
    }

  }


  async refreshData() {
    var robotData = await this.httpClient.fetchLastWarehousePingEvent();
    console.log("trying autopilotdata:")
    console.log(robotData)
    this.setState({
      robotData: robotData,
      progress: 0
    })
  }

  createDisplay(data) {
    console.log("creating display")
    var machines = []
    data.forEach(w => {
      var timeNow = moment()
      var pingTime = moment(w.pollingDateTime)
      var timeDiff = timeNow.diff(pingTime, 'minutes')
      
      var warningDiv = ''
      if(timeDiff > 10){
        warningDiv = <span>⚠️</span>
      }
      
      var temp = <Card>
        <Card.Header style={{ display: "flex", marginBottom: "0" }}>
          <p style={{ fontSize: '10px', marginBottom: "0" }}>Host: {w.machineName}</p>
          <span style={{ display: 'inline-block', width: '28%', marginBottom: "0" }} />
          <p style={{ textAlign: "center", marginBottom: "0" }}>{w.autopilotId}</p>
          <span style={{ display: 'inline-block', width: '28%', marginBottom: "0" }} />
          <p style={{ fontSize: '10px', marginBottom: "0" }}>Last Run: <p style={{ fontSize: '14px', marginBottom: "0" }}>{w.pollingDateTime}{warningDiv}</p></p>
        </Card.Header>
        <Card.Body>
          <Row>
            {this.createWarehouses(w.warehouses)}
          </Row>
        </Card.Body>
      </Card>

      machines.push(temp)
    })
    return machines;
  }

  createWarehouses(data) {
    var warehouses = []
    data.forEach(w => {
      if (w.sublocations.length > 0) {
        var temp = <div style={{ marginRight: '10px', backgroundColor: 'rgb(230, 229, 240)', border: '1px solid grey', borderRadius: '2px', padding: '6px', 
        // backgroundImage: "url(" + gnome + ")",
        // backgroundPosition: "left",
        // backgroundSize: 'contain',
        // backgroundRepeat: 'no-repeat',
        }}>
          <p style={{}}>{w.name}</p>
          {this.createSublocations(w.sublocations)}
        </div>

        warehouses.push(temp)
      }
    })
    return warehouses;
  }

  createSublocations(data) {
    var subs = []
    data.forEach(w => {
      var statusColor = (w.status === "Success") ? 'green' : 'red'

      var temp = <div style={{ marginBottom: '4px', backgroundColor: 'white', borderRadius: '3px', padding: '2px' }}>
        <div style={{ fontSize: '10px' }}>{w.name}<span style={{ display: 'inline-block', width: '28%' }} />
          {w.address}</div>
        <div style={{ fontSize: '10px' }}>Round trip: {w.roundtripTime}</div>
        <div> <div style={{
          height: '10px',
          width: '10px',
          backgroundColor: statusColor,
          borderRadius: '50%',
          display: 'inline-block'
        }} /> {w.status}</div>

      </div>

      subs.push(temp)
    })
    return subs;
  }


  async tick() {
    var tempProgress = (this.state.progress === 100) ? 1 : this.state.progress += 1
    if (tempProgress === 1) {
      await this.refreshData();

    }

    this.setState({
      progress: tempProgress
    })

    if ((this.refreshTimer) && (this.refreshTimer !== "")) {
      clearInterval(this.refreshTimer);
    }
    this.refreshTimer = setInterval(() => this.tick(), 300)
  }




  render() {

    const loadingIcon = (this.state.isLoading) ?
      <FontAwesomeIcon icon="sync-alt" color="green" spin /> :
      ""

    var disp;
    if (this.state.robotData) {
      disp = this.createDisplay(this.state.robotData)
    }
    return (
      <Card border="light" bg="light" fluid="true">
        <ProgressBar animated now={this.state.progress} />

        {disp}
      </Card>
    );
  }
}
